<template>
  <div class="company-appointment-box">
    <img :src="`${cdnresources}/prod/images/yueyangbao/lpxz-11.png`" />
    <img class="page-item" :src="`${cdnresources}/prod/images/yueyangbao/lpxz-12.png`" />
    <img class="banner" v-for="item in imgList" :key="item" v-lazy="item"/>
    <img class="page-item" style="margin-top:0px" :src="`${cdnresources}/prod/images/yueyangbao/lpxz-16.png`" />
    <div class="explain page-item">附表一： “巴陵e惠保”特定药品目录</div>
    <img class="page-itemList page-item" v-for="page in pageList" :key="page" v-lazy="page"/>
  </div>
</template>

<script>
import { cdnresources } from '@/util/config'
export default {
  data() {
    return {
      cdnresources,
      imgList: [
        cdnresources+'/prod/images/yueyangbao/lpxz-13.png',
        cdnresources+'/prod/images/yueyangbao/lpxz-14.png',
        cdnresources+'/prod/images/yueyangbao/lpxz-15.png',
      ],
      pageList: [
        cdnresources+'/prod/images/yueyangbao/cpsms-018-01.png',
        cdnresources+'/prod/images/yueyangbao/cpsms-018-02.png',
        cdnresources+'/prod/images/yueyangbao/cpsms-018-03.png',
      ]
    }
  },
  components: {

  }
}
</script>


<style scoped lang="scss">
.company-appointment-box {
  min-height: 100vh;
  background: #F6F6F6;
  padding-bottom: xvw(40);
  .banner {
    padding: 0px 10px;
    margin-bottom: 15px;
  }
  img {
    width: 100%;
    vertical-align: middle;
  }
  .page-item {
    padding: 0px 17px;
    margin: 10px 0px;
  }
  .page-itemList {
    margin: 0px;
  }
  .explain {
    margin-top: 0px;
    font-size: 12px;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
  }
}
</style>
